import { Flex, Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme";

export const PlaybookCardSection = ({
  title,
  style,
}: {
  title: string;
  style?: React.CSSProperties;
}) => {
  const { theme } = useAntTheme();
  return (
    <Typography.Title
      level={4}
      style={{
        margin: "0px -16px",
        borderBottom: theme.cardBorder,
        padding: "24px 24px 16px",
        marginBottom: 20,
        ...style,
      }}
    >
      <Flex align="center" gap={10}>
        <span
          style={{
            width: 3,
            height: "1em",
            backgroundColor: theme.colorPrimary,
            borderRadius: 2,
          }}
        />
        {title}
      </Flex>
    </Typography.Title>
  );
};
